<div class="modal-header bg-primary text-white d-flex align-items-center justify-content-between">
    <div>
        <span class="session-header-title">Delete Saved View</span>
    </div>
    <button type="button" class="close-button" aria-label="Close" (click)="closeModal()">×</button>
</div>

<div class="modal-body">
    <label>Are you sure you want to delete this view?</label>
</div>

<div class="modal-footer">
    <button type="button" class="btn btn-secondary" (click)="closeModal()">Cancel</button>
    <button type="button" class="btn btn-primary" (click)="confirmDelete()">Ok</button>
</div>